import './header.scss';
import 'magnific-popup';
export default async () => {

// Select the header element
	let headers = document.getElementsByClassName( 'header' );
	let position = window.scrollY;

	function handleScroll() {
		let scroll = window.scrollY;
		Array.from( headers ).forEach( header => {
			if ( scroll > 200 ) {
				header.classList.add( 'header--sticky' );
			} else {
				header.classList.remove( 'header--sticky' );
			}
		} );
		position = scroll;
	}

	window.addEventListener( 'scroll', handleScroll );

	// Toggle-menu
	document.querySelector( '.js-toggle-menu' ).addEventListener( 'click', function( e ) {
		e.preventDefault();
		document.body.classList.toggle( 'is-menu-open' );
	} );

	// popup-form
		var popupElement = document.querySelector('.js-popup-form');
		if (popupElement) {
			$(popupElement).magnificPopup({
				type: 'inline',
				preloader: false,
				focus: '#name'
			});
		}

};
